/** @typedef {{path, string, navigate: function}} RouteInfo */

/** @type {Object.<string, RouteInfo>} */
import featureFlags from '#/shared/feature-flags';

const { mapLibre } = featureFlags;

const ROUTES = {
  home: {
    path: '/',
    navigate: () => '/',
  },
  search: {
    path: '/search',
    navigate: () => '/search',
  },
  alerts: {
    path: '/alerts',
    navigate: () => '/alerts',
  },
  alertsById: {
    path: '/alerts/:routeId',
    navigate: (routeId, withEmail = false) =>
      `/alerts/${routeId}${withEmail ? '?email=true' : ''}`,
  },
  stopById: {
    path: '/stop/:stopId',
    navigate: stopId => `/stop/${stopId}`,
  },
  stopByIdAndRoute: {
    path: '/stop/:stopId/route/:routeId',
    navigate: (stopId, routeId) => `/stop/${stopId}/route/${routeId}`,
  },
  routes: {
    path: '/routes/*',
    navigate: () => '/routes',
  },
  routeById: {
    path: '/route/:routeId',
    navigate: routeId => `/route/${routeId}`,
  },
  location: {
    path: '/location',
    navigate: locationData =>
      `/location?address=${encodeURIComponent(locationData?.address)}&lat=${
        locationData?.lat
      }&lon=${locationData?.lon}`,
  },

  vehicle: {
    path: '/vehicle/:routeId/:blockId',
    navigate: (routeId, blockId) => `/vehicle/${routeId}/${blockId}`,
  },
  vehicleWithSelectedStop: {
    path: '/vehicle/:routeId/:blockId/stop/:selectedStopId',
    navigate: (routeId, blockId, selectedStopId) =>
      `/vehicle/${routeId}/${blockId}/stop/${selectedStopId}`,
  },
  trip: {
    path: '/planner-trip/*',
    navigate: () => '/planner-trip',
  },
  riderFeedback: {
    path: '/planner-rider-feedback/*',
    navigate: () => '/planner-rider-feedback',
  },
  planner: {
    path: '/planner/*',
    navigate: () => '/planner',
  },
  plannerModeSettings: {
    path: '/planner-mode-settings/*',
    navigate: () => '/planner-mode-settings',
  },
  plannerTimeSettings: {
    path: '/planner-time-settings/*',
    navigate: () => '/planner-time-settings',
  },
  pay: {
    path: '/planner-pay/*',
    navigate: () => '/planner-pay',
  },
  printTrip: {
    path: mapLibre ? '/print' : '/print-trip',
    navigate: () => (mapLibre ? '/print?featureFlags=mapLibre' : '/print-trip'),
  },
  menu: {
    path: '/menu',
    navigate: () => '/menu',
  },
  maplibre: {
    path: '/maplibre',
    navigate: () => '/maplibre',
  },
  maplibreStopById: {
    path: '/maplibre/stop/:stopId',
    navigate: stopId => `/maplibre/stop/${stopId}`,
  },
  maplibreStopByIdAndRoute: {
    path: '/maplibre/stop/:stopId/route/:routeId',
    navigate: (stopId, routeId) => `/maplibre/stop/${stopId}/route/${routeId}`,
  },
  // this item is for path matching outside the render cycle;  it will
  // match any non-null pathname when used with path matching logic
  all: {
    path: '*',
  },
};

export default ROUTES;
